<template>
	<ErrorPage
		:code="$t('views.notFound.code')"
		:page-title="$t('views.notFound.error')"
		:message="$t('views.notFound.message')"
		data-cy="errorPage"
	/>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { Meta, MetaInfo } from '@/decorators';

	/** 404 page */
	@Component
	export default class NotFound extends Vue {
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: this.$t('views.notFound.meta.title') as string,
				meta: [
					{
						name: 'description',
						vmid: 'description',
						content: this.$t('views.notFound.meta.description') as string
					}
				]
			};
		}
	}
</script>
